import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { RentalObjectKey } from '../../model/rental-object-key';
import { RentalObjectKeyService } from '../../service/data/rental-object-key.service';
import { KeyTypeService } from '../../service/data/key-type.service';
import { RentalObjectService } from '../../service/base/rental-object';
import { CompanyService } from '../../service/data/company.service';
import { PropertyService } from '../../service/data/property.service';
import { BuildingService } from '../../service/data/building.service';
import { EntranceService } from '../../service/data/entrance.service';

@Component({
    selector: 'app-rental-object-key-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectKeyManagerComponent extends PagedObjectManagerComponent<RentalObjectKey> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: RentalObjectKeyService,
    private _companyService: CompanyService,
    private _propertyService: PropertyService,
    private _buildingService: BuildingService,
    private _entranceService: EntranceService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    private _keyTypeService: KeyTypeService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getRentalObjectKeyColumnDefinition();
    this.title = 'RENTALOBJECT_KEY.KEYS';
    this.preferencesKey = 'rent.rental-object-key.list';

    // Export to Excel
    this.showExcelExportButton = true;
    this.excelFileName = 'Nycklar'; // TODO: translate dynamically
    this.excelContext = 'RentalObjectKeys';
    this.excelColumnDefinition = [...this.columnDefinition];
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'COMMON.COMPANY',
            'companyId',
            definition.companyId,
            this._companyService,
            definition.selectedFields.includes('companyId')
          ),
          new FilterDefinitionItem(
            'COMMON.PROPERTY',
            'propertyId',
            definition.propertyId,
            this._propertyService,
            definition.selectedFields.includes('propertyId')
          ),
          new FilterDefinitionItem(
            'COMMON.BUILDING',
            'buildingId',
            definition.buildingId,
            this._buildingService,
            definition.selectedFields.includes('buildingId')
          ),
          new FilterDefinitionItem(
            'ENTRANCE.ENTRANCE',
            'entranceId',
            definition.entranceId,
            this._entranceService,
            definition.selectedFields.includes('entranceId')
          ),
          new FilterDefinitionItem(
            'KEYTYPE.KEYTYPE',
            'keyTypeId',
            definition.keyTypeId,
            this._keyTypeService,
            definition.selectedFields.includes('keyTypeId')
          ),
          new FilterDefinitionItem(
            'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL',
            'rentalId',
            definition.rentalId,
            null,
            definition.selectedFields.includes('rentalId')
          ),
          new FilterDefinitionItem(
            'RENTALOBJECT_KEY.KEY',
            'keyContains',
            definition.keyContains,
            null,
            definition.selectedFields.includes('keyContains')
          ),
          new FilterDefinitionItem(
            'RENTALOBJECT_KEY.CAPTION',
            'captionContains',
            definition.captionContains,
            null,
            definition.selectedFields.includes('captionContains')
          ),
          new FilterDefinitionItem(
            'RENTALOBJECT_KEY.MARKING',
            'markingContains',
            definition.markingContains,
            null,
            definition.selectedFields.includes('markingContains')
          ),
          new FilterDefinitionItem(
            'RENTALOBJECT_KEY.SUPPLIER',
            'supplierContains',
            definition.supplierContains,
            null,
            definition.selectedFields.includes('supplierContains')
          ),
          new FilterDefinitionItem(
            'RENTALOBJECT_KEY.SYSTEM_NUMBER',
            'systemNumberContains',
            definition.systemNumberContains,
            null,
            definition.selectedFields.includes('systemNumberContains')
          ),
        ];
      })
    );
    this.addEditDeleteCommands();
  }
}
